import React from "react";
import Table from "react-bootstrap/Table";
import ListHeader from "./ListHeader";
import ComboWithOptions from "./ComboWithOptions";
import CostCells from "./CostCells";
import DeleteCell from "./DeleteCell";

function GenericList(props) {

    function getUpdatedList() {
        let list = props.list ? [...props.list] : []
        list.push({emptyCell: true})
        return list
    }

    function getValue(item) {
        return item.emptyCell? "" : item[props.singleName][props.instanceName]
    }

    return (
        <div>
            <label className="form-label">{props.label}</label>
            <Table responsive striped bordered hover>
                <ListHeader headers={props.headers}/>
                <tbody>
                {getUpdatedList().map((item, index) => (
                    <tr key={index}>
                        <ComboWithOptions options={props.options} optionDisplay={props.optionDisplay} select={props.select}
                                          value={getValue(item)} ndx={props.ndx} index={index}
                                          name={props.mainColumnName}
                        />
                        {props.getAdditionalCells && props.getAdditionalCells(item, index)}
                        <CostCells update={props.update} list={props.list} ndx={props.ndx} index={index} item={item}
                                   singleName={props.singleName} separateSellPrice={props.separateSellPrice} emptyCell={item.emptyCell}/>
                        <DeleteCell delete={props.delete} ndx={props.ndx} index={index} emptyCell={item.emptyCell}/>
                    </tr>
                ))}
                </tbody>
            </Table>
        </div>
    )
}

export default GenericList
